import React from 'react'
import { Tag as AntTag, TagProps } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'

const colorMapping = {
  active: '#37a365',
  inactive: 'default',
  blocked: '#ff1515',
  pending: '#FF9898',
  suspended: '#FBA21C',
  bing: 'geekblue',
  dv360: 'lime',
  google: 'green',
  meta: 'blue',
  snapchat: 'gold',
  taboola: 'cyan',
  tiktok: 'red',
  zemanta: 'orange',
  default: 'magenta', // Sensible default
}

const CustomTag = (prop: TagProps) => {
  if (!prop.children) {
    return <></>
  }

  const childText = prop.children.toString()
  const color =
    colorMapping[childText.toLowerCase() as keyof typeof colorMapping] || colorMapping.default

  return (
    <AntTag
      color={color}
      closeIcon={prop.closable && <CloseCircleOutlined color={'textColor'} />}
      {...prop}
    >
      {prop.children}
    </AntTag>
  )
}

export default CustomTag
